import { createSlice } from '@reduxjs/toolkit';

let _id = 0;

const slice = createSlice({
  name: 'toast',
  initialState: { list: [] },
  reducers: {
    //payload: { type: 'success' | 'error', msg }
    toastify: (state, action) => {
      const { type, msg } = action.payload || {};
      if (!msg) return;
      _id += 1;
      state.list.push({ id: _id, error: type === 'error', msg: String(msg) });
      if (state.list.length > 3) state.list.shift();
    },
    removeToast: (state, action) => {
      state.list = state.list.filter((t) => t.id !== action.payload);
    }
  }
});

export const { toastify, removeToast } = slice.actions;
export default slice.reducer;
